import React, { createContext, useCallback, useContext, useState } from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

const ToastContext = createContext(null);

export const ToastProvider = ({ children }) => {
  const [toast, setToast] = useState({
    open: false,
    message: "",
    severity: "info", // success | error | warning | info
  });

  const show = useCallback((message, severity = "info") => {
    setToast({ open: true, message, severity });
  }, []);

  const hide = () => {
    setToast((t) => ({ ...t, open: false }));
  };

  const api = {
    success: (msg) => show(msg, "success"),
    error: (msg) => show(msg, "error"),
    warning: (msg) => show(msg, "warning"),
    info: (msg) => show(msg, "info"),
  };

  return (
    <ToastContext.Provider value={api}>
      {children}

      <Snackbar
        open={toast.open}
        autoHideDuration={3500}
        onClose={hide}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={hide}
          severity={toast.severity}
          variant="filled"
          sx={{ alignItems: "center" }}
        >
          {toast.message}
        </Alert>
      </Snackbar>
    </ToastContext.Provider>
  );
};

// Hook interno (no exportes el contexto directamente)
export const useToastContext = () => {
  const ctx = useContext(ToastContext);
  if (!ctx) {
    throw new Error("useToast debe usarse dentro de <ToastProvider>");
  }
  return ctx;
};
